import { Col, Row } from "antd";
import BoxSectionItem from "../../../../../../../components/box-section/box-section-item";
import { DateHelper, StringHelper } from "../../../../../../../helper";
import { Moment } from "moment";
import { DateFormat } from "../../../../../../../constants";

interface Props {
  data: any;
}

export const MaternityLeaveApplicationDetail = ({ data }: Props) => {
  const eVacationPeriodText = () => {
    return data?.eVacationPeriods
      .map((i: Moment[]) =>
        DateHelper.formatRangeDateToString(i, {
          format: DateFormat.DD_MM_YYYY_HH_MM,
        }),
      )
      .join(", ");
  };

  return (
    <Row gutter={[32, 0]}>
      <Col span={12} xs={24} lg={12}>
        <BoxSectionItem
          textLeft="Họ và tên người tạo đơn"
          textRight={StringHelper.verticalBarSplit(data?.eCreatedBy)[1]}
        />
      </Col>
      <Col span={12} xs={24} lg={12}>
        <BoxSectionItem textLeft="Họ và tên" textRight={data?.eRequestName} />
      </Col>
      <Col span={12} xs={24} lg={12}>
        <BoxSectionItem textLeft="Chức danh" textRight={StringHelper.verticalBarSplit(data?.eTitle)[1]} />
      </Col>
      <Col span={12} xs={24} lg={12}>
        <BoxSectionItem textLeft="Cơ quan/Đơn vị" textRight={StringHelper.verticalBarSplit(data?.eDepartment)[1]} />
      </Col>
      <Col span={12} xs={24} lg={12}>
        <BoxSectionItem textLeft="Đơn vị" textRight={StringHelper.verticalBarSplit(data?.eUnit)[1]} />
      </Col>
      <Col span={12} xs={24} lg={12}>
        <BoxSectionItem textLeft="Đội/Nhóm" textRight={StringHelper.verticalBarSplit<string[]>(data?.eTeam)[1]} />
      </Col>
      <Col span={12} xs={24} lg={12}>
        <BoxSectionItem textLeft="Email" textRight={data?.eEmail} />
      </Col>
      <Col span={12} xs={24} lg={12}>
        <BoxSectionItem textLeft="Số điện thoại" textRight={data?.ePhone} />
      </Col>
      <Col span={12} xs={24} lg={12}>
        <BoxSectionItem textLeft="Thời gian xin nghỉ " textRight={eVacationPeriodText()} />
      </Col>
      <Col span={12} xs={24} lg={12}>
        <BoxSectionItem
          ellipsis
          textLeft="Thời gian (dự kiến) quay trở lại làm việc"
          textRight={DateHelper.formatDateToString(data?.eExpectedReturnDate)}
        />
      </Col>

      <Col span={12} xs={24} lg={12}>
        <BoxSectionItem textLeft="Lý do" textRight={data?.eReason} />
      </Col>
    </Row>
  );
};
